import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';

import usePrevious from '~/hooks/usePrevious';

import styles from './ProgressBar.module.scss';

export interface IProgressBarProps {
  target: number;
  targetMax: number;
  value: number;
  isAnimated: boolean;
}

const ProgressBar: React.FC<IProgressBarProps> = ({
  target,
  targetMax,
  value = 0,
  isAnimated,
}) => {
  const areAnimationsAllowed = useRef(false);
  const prevValue = usePrevious(value);

  useEffect(() => {
    if (isAnimated && !areAnimationsAllowed.current) {
      areAnimationsAllowed.current = true;
    }
  }, [isAnimated]);

  const isOverTarget = value > target;

  return (
    <div
      className={classNames(styles.container, {
        [styles.animated]: areAnimationsAllowed.current,
      })}
    >
      <div className={styles.track}>
        <div
          className={styles.bar}
          style={{
            maxWidth: isOverTarget ? '100%' : `${(value * 100) / target}%`,
          }}
        />
        <div
          className={styles.maxBar}
          style={{
            maxWidth: isOverTarget
              ? `${((value - target) * 100) / (targetMax - target)}%`
              : '0',
            transitionDelay:
              prevValue < target && isOverTarget ? '0.5s' : 'unset',
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(ProgressBar);
